// extracted by mini-css-extract-plugin
export var image = "MarkdownImage-module--image--71ce1";
export var root = "MarkdownImage-module--root--82543";
export var wrapper = "MarkdownImage-module--wrapper--83b2c";